import { render, staticRenderFns } from "./CustomerNotifications.vue?vue&type=template&id=36d3734e"
import script from "./CustomerNotifications.vue?vue&type=script&lang=js"
export * from "./CustomerNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports